import { Component } from 'react';
import Raven from 'raven-js';
import { Layer } from 'foundations-components/transitional/components/Layer';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
class LoadingComponent extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.error !== prevProps.error && this.props.error instanceof Error) {
      Raven.captureException(this.props.error);
    }
  }
  render() {
    return this.props.pastDelay ? /*#__PURE__*/_jsx(Layer, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          position: 'fixed',
          zIndex: 1211
        },
        children: /*#__PURE__*/_jsx(LoadingOverlay, {})
      })
    }) : null;
  }
}
export default LoadingComponent;